<template>
  <div
    v-if="showLoadingState < 3"
    key="loadingState"
    class="m-initial-loading"
  >
    <AtomLoadingPrimary/>
  </div>
  <div
    v-else
    key="initialSetup"
    class="m-card-primary m-initial-setup"
  >
    <AtomLogoPrimary/>
    <h1 class="font-weight-bold">
      {{ $t('mInitialSetup.greeting') }}
      <span class="text-color-academy-primary">{{ usuarioNombre }}</span>,
      {{ $t('mInitialSetup.gratefulness') }}
      <i class="far fa-smile text-color-success"></i>
    </h1>
    <form
      autocomplete="off"
      class="a-form-column"
      name="create-academia-form"
      @submit.prevent="createAcademia"
    >
      <p class="margin-bottom-xxlarge">
        {{ $t('mInitialSetup.formInfo') }}
      </p>

      <AtomInputPrimary
        v-model="academia.nombre"
        :inputError="$v.academia.nombre.$error"
        :label="$t('mInitialSetup.inputs.nombre.label')"
        :message="$t('mInitialSetup.inputs.nombre.message')"
        :messageError="messageErrorNombre"
        name="nombre"
        :placeholder="$t('mInitialSetup.inputs.nombre.placeholder')"
        type="text"
        @blur="$v.academia.nombre.$touch()"
      />

      <AtomInputGroupPrimary
        v-model.trim="academia.url"
        :inputError="$v.academia.url.$error || urlInUse"
        :label="$t('mInitialSetup.inputs.url.label')"
        :message="$t('mInitialSetup.inputs.url.message')"
        :messageError="messageErrorUrl"
        name="url"
        :placeholder="$t('mInitialSetup.inputs.url.placeholder')"
        :span-input="academiaDomain"
        type="text"
        @blur="$v.academia.url.$touch()"
      />

      <AtomSelectPrimary
        v-model.number="academia.categoria"
        :elements="academiaCategorias"
        :inputError="$v.academia.categoria.$error"
        keyField="id"
        :label="$t('mInitialSetup.inputs.categoria.label')"
        :messageError="messageErrorCategoria"
        name="categoria"
        textField="nombre"
        @blur="$v.academia.categoria.$touch()"
      />

      <AtomButtonPrimary :button-primary="buttonPrimary"/>
    </form>
  </div>
</template>

<script>
import abilities from '@/plugins/permissions/abilities'
import permissions from '@/plugins/permissions'
import { maxLength, minLength, required } from 'vuelidate/lib/validators'

export default {
  name: 'MoleculeInitialSetup',

  data () {
    return {
      academia: {
        categoria: '',
        licencia: '',
        nombre: '',
        url: ''
      },

      academiaCategorias: [],
      academiaDomain: '',

      buttonPrimary: {
        action: this.$t('mInitialSetup.buttonPrimary'),
        class: 'a-button-academy-primary',
        sending: false,
        type: 'submit'
      },

      currentResources: {},
      licencia: {},
      showLoadingState: 0,
      usuarioNombre: '',
      urlInUse: false,
      isLicenciaPaga: false
    }
  },

  validations: {
    academia: {
      categoria: {
        required
      },

      nombre: {
        maxLength: maxLength(60),
        minLength: minLength(5),
        required
      },

      url: {
        maxLength: maxLength(120),
        minLength: minLength(3),
        required
      }
    }
  },

  computed: {
    messageErrorCategoria () {
      return this.$validation.getValidationMessage('mInitialSetup', this.$v.academia.categoria, 'categoria')
    },

    messageErrorNombre () {
      return this.$validation.getValidationMessage('mInitialSetup', this.$v.academia.nombre, 'nombre')
    },

    messageErrorUrl () {
      if (this.urlInUse) {
        return 'La Url ingresada ya está en uso, intenta con una diferente. De 3 a 120 caracteres.'
      } else {
        return this.$validation.getValidationMessage('mInitialSetup', this.$v.academia.url, 'url')
      }
    }
  },

  watch: {
    'academia.url' () {
      this.academia.url = this.$utils.stringToSlug(this.academia.url)
      this.validateAcademyUrlInUse()
    }
  },

  created () {
    this.academiaDomain = `${this.$utils.getMarketPlaceDomain()}/`
    this.usuarioNombre = this.$store.getters.getUserData.vidroop_data.persona.razon_social
    this.readAcademiaCategorias()
    this.readLicenciasUsuario()
  },

  methods: {
    createAcademia () {
      this.$v.$touch()
      if (!this.$v.$invalid && !this.urlInUse && !this.buttonPrimary.sending) {
        this.buttonPrimary.sending = true
        this.$services.create('academia', 'createAcademia', this.academia)
          .then(response => {
            let currentAcademy = Object.assign({}, response.data)
            currentAcademy.current_ability = 'administrador'
            permissions.update([...abilities['administrador']])
            currentAcademy.licencia = Object.assign({}, this.licencia)
            currentAcademy.is_licencia_paga = this.isLicenciaPaga
            localStorage.setItem('current_academy', JSON.stringify(currentAcademy))
            this.$store.commit('setAcademyData', currentAcademy)
            this.$auth.readAcademiaRecursosUsados(currentAcademy)
            this.$alerts.pushAlert('mInitialSetup', 'createAcademia', 'success')
            this.buttonPrimary.sending = false
            this.$router.push({ name: 'home' })
          })
          .catch(error => {
            console.log(error)
            this.$alerts.pushAlert('mInitialSetup', 'createAcademia', 'error', 'a-alert-danger')
            this.buttonPrimary.sending = false
          })
      }
    },

    readAcademiaCategorias () {
      this.$services.read('academia', 'readAcademiaCategorias')
        .then(response => {
          this.academiaCategorias = response.data
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    },

    readLicenciasUsuario () {
      this.$services.read('licencia', 'readLicenciasUsuario')
        .then(response => {
          let licencia = response.data.find(licencia => licencia.id === this.$route.params.id &&
          licencia.academia === undefined)
          if (licencia !== undefined) {
            this.academia.licencia = licencia.id
            this.licencia = Object.assign({}, licencia)
            this.readVenta()
            this.showLoadingState++
          } else {
            this.$router.push({ name: 'home' })
          }
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    },

    readVenta () {
      this.$services.read('ventas', 'readVenta', {}, [this.licencia.venta])
        .then(response => {
          let venta = response.data
          if (venta.venta.precio > 0) {
            this.isLicenciaPaga = true
          } else {
            this.isLicenciaPaga = false
          }
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    },

    validateAcademyUrlInUse () {
      if (this.academia.url !== '') {
        this.$services.read('academia', 'readAcademiaValidUrl', {}, ['-', this.academia.url])
          .then(response => {
            this.urlInUse = response.data
          })
          .catch(error => {
            console.log(error)
          })
      }
    }
  }
}
</script>
